"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var dnd_core_1 = require("dnd-core-cjs");
/**
 * Create the React Context
 */
exports.DndContext = React.createContext({
    dragDropManager: undefined,
});
/**
 * Creates the context object we're providing
 * @param backend
 * @param context
 */
function createDndContext(backend, context, options, debugMode) {
    return {
        dragDropManager: dnd_core_1.createDragDropManager(backend, context, options, debugMode),
    };
}
exports.createDndContext = createDndContext;
